<template>
  <div class="">
    <h2>Default Content Hello</h2>
    <ul v-if="myrooms">
      <li v-for="item in myrooms" :key="item.uid">
        <!--TODO Add link-->
        {{ item.title }}
      </li>
    </ul>

    <hr />
   
  </div>
</template>

<script>
export default {
  name: "DashboardUser",

  data() {
    return {
      myrooms: undefined,
      serach: undefined,
      result: undefined,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.$store.state.modules.api
        .getAllRooms(JSON.parse(localStorage.account).token, 0, 100)
        .then((resp) => {
          this.myrooms = resp.data.units;
          this.$store.state.utils.loaded = true;
        });
    });
  },
  methods: {

  },
};
</script>
